/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SetAsClosedModel as DigiworkMaitreDPosDtoOrderSetAsClosedModel } from '../../models/Digiwork/MaitreD/Pos/DTO/Order/set-as-closed-model';

export interface SetOrderBillAsClosed$Params {
      body?: DigiworkMaitreDPosDtoOrderSetAsClosedModel
}

export function setOrderBillAsClosed(http: HttpClient, rootUrl: string, params?: SetOrderBillAsClosed$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, setOrderBillAsClosed.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

setOrderBillAsClosed.PATH = '/api/wtr/OrderBill/setorderbillasclosed';
